import { useMemo } from "react";

import invariant from "tiny-invariant";

const useAnnotationCoordinates = (
  map?: google.maps.Map,
  projection?: google.maps.MapCanvasProjection,
  position?: google.maps.LatLng | google.maps.LatLngLiteral,
  coordinates?: { left: number; top: number }
) => {
  invariant(
    coordinates || (map && position),
    `Invalid useAnnotationCoordinates usage: either coordinates or map+position must be defined`
  );

  return useMemo(() => {
    if (coordinates) {
      return coordinates;
    }

    if (!projection) {
      return { left: 0, top: 0 };
    }

    const mapContainer = map!.getDiv();
    const scrollTop = (document.scrollingElement || document.documentElement).scrollTop;
    const scrollLeft = (document.scrollingElement || document.documentElement).scrollLeft;
    const mapRect = mapContainer.getBoundingClientRect();
    const mapX = mapRect.left + scrollLeft;
    const mapY = mapRect.top + scrollTop;

    // This is a tricky way to correctly convert LatLng into screen pixel (within map div).
    // I found this way more reliable than the one used in useMapProjection.
    // Specifically, useMapProjection wasn't returning correct results on a certain zoom levels
    // (approx. 1-6) when the International Date Line was in view (not necessarily in the middle).
    // Interestingly, Y-coordinate was always correct with useMapProjection.
    const containerPixel = projection.fromLatLngToContainerPixel(position!);

    if (containerPixel) {
      return { left: containerPixel.x + mapX, top: containerPixel.y + mapY };
    }

    return { left: mapX, top: mapY };
  }, [map, position, projection, coordinates]);
};

export default useAnnotationCoordinates;
